<template>
    <div class="chapter">
        <headers :title='title'></headers>
        <template v-if="loading">
            <template v-if="!Object.keys(book).length">
                <div class="no-book">
                    <p class="p1"></p>
                    <p class="p2">您暂未设置<em>教材</em></p>
                    <p class="p3">请设置一本<em>教材</em>吧，设置过后才能布置作业</p>
                    <a href="javascript:;"
                       class="set-book"
                       @click="setbook">设置教材</a>
                </div>
            </template>
            <template v-else>
                <div class="title">
                    <i class="icon-book"></i>
                    <p>{{book.book_name}}</p>
                    <a href="javascript:;"
                       class="set-book"
                       @click="setbook">更换<em>教材</em><i class="enter"></i></a>
                </div>
                <div class="list"
                     v-if="list.length">
                    <template v-if="type==1">
                        <div class="list-box"
                             v-for="(l,lind) in list">
                            <div :class="[lind?'list_con':'list_con first_border']">
                                <i class="list_book"></i>
                                <p>{{lind+1}}.{{l.name}}</p>
                                <i :class="l.choise ? 'list_active' : 'list_noactive'"
                                   @click="select(l,true)"></i>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div v-for="(l,lind) in list">
                            <div :class="[lind?'list_con':'list_con first_border']"
                                 @click="select(l,false)">
                                <i class="list_book"></i>
                                <p>{{lind+1}}.{{l.name}}</p>
                                <i :class="l.choise ? 'list_close' : 'list_open'"
                                   v-if="l.children.length"></i>
                            </div>
                            <transition name="my-slide"
                                        tag="div">
                                <div class="list_children_wrap"
                                     v-show="l.choise"
                                     :style="`height:${l.children.length * 2.4}rem`">
                                    <div class="list_children"
                                         v-for="(c,cind) in l.children">
                                        <p>{{c.name}}</p>
                                        <i :class="c.choise ? 'list_active' : 'list_noactive'"
                                           @click="select(c,true)"></i>
                                    </div>
                                </div>
                            </transition>
                        </div>
                    </template>

                </div>
                <noResouse v-else></noResouse>
                <div class="bottom_btn">
                    <a class="btn_a"
                       v-if='catalogId.length'
                       @click='next'>下一步</a>
                    <a v-else>下一步</a>
                </div>
            </template>
        </template>
        <template v-else>
            <loadingS></loadingS>
        </template>
    </div>
</template>

<script type="text/ecmascript-6">
import headers from 'COMPONENTS/base/header.vue';
import loadingS from 'COMPONENTS/base/tealoading.vue';
import noResouse from 'COMPONENTS/noResouse.vue';

export default {
    data () {
        return {
            title: '',
            loading: false,//接口是否返回数据
            list: [],
            book: {},
            catalogId: [],//选中的章节id,先利用Object的特性处理选中的数据，最后用Object.values()转换为数组
            next_btn: false,
            sid: this.$route.params.sid,
            type: this.$route.params.type,  //0同步习题 1单元复习
            book_type: 0,
            code: '016',
        }
    },
    components: {
        headers, loadingS, noResouse
    },
    methods: {
        setbook () {
            this.$router.push('/setBook/51/1/8?task_type=' + this.type)
        },
        next () {
            localStorage.removeItem('activeData')
            localStorage.removeItem('activeIds')
            /**根据ch_id查章节id  然后跳转*/
            let paper_id = [];
            this.$http.post(API_URL_TASK_API + '/chinese/make/exercises_paper', {
                ch_id: this.catalogId.join(','),
                type: this.type,
                sid: this.sid
            }).then(res => {
                res = res.data;
                if (res.response === 'ok') {
                    if (!res.data[0].question_data.length) {
                        layer.open({
                            title: "提示",
                            content: '<div class="norecorse"><span class="img"></span><h3>暂无资源</h3> </div>',
                            btn: '确定',
                            yes: function () {
                                layer.closeAll();
                            }
                        });
                        localStorage.removeItem('paperIds');
                        return false
                    } else {
                        res.data.forEach(l => {
                            l.question_data.forEach(v => {
                                paper_id.push(v.paper_id)
                            })
                        });
                        localStorage.setItem('paperIds', paper_id.join(','));
                        localStorage.setItem('ch_id', this.catalogId.join(','));

                        setTimeout(() => {
                            this.$router.push('/chinese/select_task/select_test/' + this.sid + '/' + this.type + '?tarType=1');
                        }, 300)
                    }

                }
            })
        },
        select (l, flag) {
            l.choise = !l.choise;
            this.list.splice(0, 1, this.list[0]);
            if (flag) {
                if (l.choise) {
                    this.catalogId.push(l.ch_id);
                } else {
                    this.catalogId.forEach((v, i) => {
                        if (v === l.ch_id) {
                            this.catalogId.splice(i, 1);
                        }
                    })
                }
            }
        },
        getList () {
            this.$http.post(API_URL_TASK_API + '/chinese/check/chapter/list', {
                sid: this.sid,
                grade_id: this.book.grade_id,
                book_type: this.book_type,
                book_id: this.book.id,
                type: this.type
            }).then(res => {
                res = res.data;
                if (res.response === 'ok') {
                    this.loading = true;
                    this.list = res.data;
                    this.list.forEach(item => {
                        item.choise = false;
                        item.children.forEach(v => {
                            v.choise = false;
                        });
                    })
                }
            })
        }
    },
    async created () {
        let chinese_send_ok = localStorage.getItem('chinese_send_ok');
        if (chinese_send_ok == 1) {
            this.$router.go(-1);
            return false;
        }
        this.title = this.type == 0 ? '同步习题' : '单元复习';
        await this.$http.post(API_URL_TASK_API + '/public/book/user_book', {
            sid: this.sid,
            book_type: this.book_type,
            code: this.code
        }).then(res => {
            res = res.data;
            if (res.response === 'ok') {
                this.book = res.data;
                if (Object.keys(this.book).length) {
                    this.getList();
                } else {
                    this.loading = true;
                }
            }
        })
    },
    destroyed () {
        localStorage.removeItem('activeData')
        localStorage.removeItem('activeIds')
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "./src/assets/scss/common/_mixin";

.chapter {
    padding-bottom: 96px / $ppr;
    min-height: 100vh;
    box-sizing: border-box;
    .header-wrap {
        .header {
            background: #5e89ef;
        }
        .left {
            width: 18px / $ppr;
            height: 34px / $ppr;
            background: url("./img/white_back.png") no-repeat;
            background-size: 100% 100%;
        }
    }
    .no-book {
        //无教材
        margin-top: 325px / $ppr;
        width: 100%;
        height: auto;
        .p1 {
            margin: 0 auto;
            width: 136px / $ppr;
            height: 112px / $ppr;
            background: url("img/icon_nobook.png") no-repeat;
            -webkit-background-size: 100% 100%;
            background-size: 100% 100%;
        }
        .p2 {
            width: 100%;
            text-align: center;
            color: #333;
            font-size: 36px / $ppr;
            line-height: 36px / $ppr;
            margin: 40px / $ppr 0 16px / $ppr 0;
        }
        .p3 {
            width: 100%;
            text-align: center;
            color: #999;
            font-size: 24px / $ppr;
            line-height: 24px / $ppr;
            margin-bottom: 40px / $ppr;
        }
        .set-book {
            display: block;
            margin: 0 auto;
            width: 360px / $ppr;
            height: 82px / $ppr;
            line-height: 82px / $ppr;
            text-align: center;
            font-size: 34px / $ppr;
            color: #fff;
            border-radius: 40px / $ppr;
            background: #5e89ef;
        }
    }
    .title {
        margin-bottom: 24px / $ppr;
        padding: 0 24px / $ppr;
        height: 96px / $ppr;
        background: #fff;
        .icon-book {
            display: block;
            float: left;
            margin: 31px / $ppr 24px / $ppr 0 0;
            width: 34px / $ppr;
            height: 34px / $ppr;
            background: url("img/icon_setbook.png") no-repeat;
            background-size: 100% 100%;
        }
        p {
            float: left;
            width: 400px / $ppr;
            line-height: 96px / $ppr;
            font-size: 30px / $ppr;
            color: #333;
            @include ellipsis;
        }
        .set-book {
            position: relative;
            display: block;
            float: right;
            padding-right: 30px / $ppr;
            line-height: 96px / $ppr;
            font-size: 30px / $ppr;
            color: #5e89ef;
            .enter {
                display: block;
                position: absolute;
                top: 50%;
                right: 0;
                margin-top: -13px / $ppr;
                width: 14px / $ppr;
                height: 26px / $ppr;
                background: url("./img/enter.png") no-repeat;
                background-size: 100% 100%;
            }
        }
    }
    .list {
        background: #fff;
        .list_children {
            background: #f0f0f0;
        }
        .list_con,
        .list_children {
            position: relative;
            padding: 0 24px / $ppr 0 82px / $ppr;
            height: 96px / $ppr;
            line-height: 96px / $ppr;
            border-top: 1px / $ppr solid #e8e8e8;
            &.first_border {
                border-top: none;
            }
            .list_book {
                display: block;
                position: absolute;
                top: 50%;
                left: 24px / $ppr;
                margin-top: -16px / $ppr;
                width: 34px / $ppr;
                height: 32px / $ppr;
                background: url("img/icon_book.png") no-repeat;
                background-size: 100% 100%;
            }
            p {
                font-size: 30px / $ppr;
                color: #333;
                @include ellipsis;
            }
            .list_active {
                display: block;
                position: absolute;
                right: 24px / $ppr;
                top: 50%;
                margin-top: -20px / $ppr;
                width: 40px / $ppr;
                height: 40px / $ppr;
                background: url("img/icon_select.png") no-repeat;
                background-size: 100% 100%;
            }
            .list_noactive {
                display: block;
                position: absolute;
                right: 24px / $ppr;
                top: 50%;
                margin-top: -20px / $ppr;
                width: 40px / $ppr;
                height: 40px / $ppr;
                background: url("img/icon_unchecked.png") no-repeat;
                background-size: 100% 100%;
            }
            .list_open {
                display: block;
                position: absolute;
                right: 24px / $ppr;
                top: 50%;
                margin-top: -6.5px / $ppr;
                width: 25px / $ppr;
                height: 13px / $ppr;
                background: url("img/icon_open.png") no-repeat;
                background-size: 100% 100%;
            }
            .list_close {
                display: block;
                position: absolute;
                right: 24px / $ppr;
                top: 50%;
                margin-top: -6.5px / $ppr;
                width: 25px / $ppr;
                height: 13px / $ppr;
                background: url("img/icon_close.png") no-repeat;
                background-size: 100% 100%;
            }
        }
    }
    .bottom_btn {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100vw;
        a {
            display: inline-block;
            width: 100%;
            height: 97px / $ppr;
            line-height: 97px / $ppr;
            text-align: center;
            font-size: 36px / $ppr;
            //font-weight: bold;
            color: #999999;
            background-color: $line;
            &.btn_a {
                color: #fff;
                background-color: #5e89ef;
            }
        }
    }
}
.list_children_wrap {
    height: 0;
    overflow: hidden;
    transition: height 0.3s linear;
}
.my-slide-enter,
.my-slide-leave-to {
    height: 0 !important;
}
</style>
